import {
  collection,
  query,
  doc,
  getDocs,
  setDoc,
  // orderBy
} from "firebase/firestore";
import { auth, db } from "../firebase";

export const createProject = async (data) => {
  const { subContractor, images, ...rest } = data;
  const projectRef = doc(db, `users/${auth.currentUser?.uid}/projects`, data?.nickName);
  try {
    if (subContractor.length > 0) {
      await setDoc(projectRef, {
        ...data,
      });
      return "success";
    } else {
      await setDoc(projectRef, {
        ...rest,
      });
      return "success";
    }
  } catch (e) {
    console.error("Error adding document: ", e);
  }
};


export const getProjectDetails = async(projectName) => {
  const detailsRef = query(collection(db, `users/${auth.currentUser?.uid}/projects/${projectName}/projectDetails/`));
  const querySnapshot = await getDocs(detailsRef);
  return querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
}

export const addProjectNote = async (data) => {
  const noteRef = doc(collection(db, `users/${auth.currentUser?.uid}/projects/${data?.projectName}/projectDetails`));
  await setDoc(noteRef, data);
  return "success";
};